import { render, staticRenderFns } from "./CartaoOrdemDePagamento.vue?vue&type=template&id=5494e14b&scoped=true"
import script from "./CartaoOrdemDePagamento.vue?vue&type=script&setup=true&lang=js"
export * from "./CartaoOrdemDePagamento.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CartaoOrdemDePagamento.vue?vue&type=style&index=0&id=5494e14b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5494e14b",
  null
  
)

export default component.exports